import _ from "lodash";
import { IModelData } from "../../atoms";
import { IDropdownOption } from "./Inputs";
import { dropdownFields } from "../../utils/customisation";

// Form Utils
// ---------

// omit these column names from form
const omitFieldsFromForm = ["id", "sort_id", "updated_at", "created_at"];

// map types to correct form fields
export const mapFormFields = (type: string) => {
  switch (type) {
    case "float":
    case "integer":
      return "number";
  }
  return type;
};

//
/**
 * returns [data, schema] from model object
 * @param modelData Whole array of model data from /data/models
 * @param modelName Name of model to extract
 * @param excludeIds Boolean as to whether or not to exclude fields from omitFieldsFromForm
 * @returns
 */
export const getDataAndSchemaFromModel = (
  modelData: IModelData[],
  modelName: string,
  excludeIds: boolean,
): [Object, any[], any[]] => {
  // Find model and get keys
  const model = modelData.find((md) => md.name === modelName);
  const modelFields = model?.fields;
  const fieldKeys = modelFields ? Object.keys(modelFields) : [];

  // Get relationships of model
  const modelRelationships = model?.relationships || [];

  // Get schema of model
  // Reduce schema to omit certain keys like 'id' and 'ownernodesid'
  const formSchema = fieldKeys.reduce((arr: any[], fk: string) => {
    // Check against omitFields array
    if (excludeIds && _.includes(omitFieldsFromForm, fk)) return arr;
    // Remove relational array
    if (fk.startsWith("owner") && fk.endsWith("id")) return arr;
    return [...arr, { name: fk, type: mapFormFields(modelFields[fk]) }];
  }, []);

  // Grab data that is updated and used to fill in the form
  const data = fieldKeys.reduce((obj, fk) => {
    return { ...obj, [fk]: undefined };
  }, {});

  return [data, formSchema, modelRelationships];
};

/**
 * LWfn - Check if is a dropdown, and return options if so. Otherwise return null.
 */
export const checkDropdown = (
  fieldName: string,
  modelName?: string,
): IDropdownOption[] | null => {
  const checkIfInList = dropdownFields.find((ddField) => {
    return (
      (!modelName || ddField.model === modelName) && fieldName === ddField.field
    );
  });
  if (checkIfInList) return checkIfInList.options;
  return null;
};

/**
 * Get params string object to be added to itemData when updating/creating items
 * @param originFrom 'from' from URL search params
 * @param originId 'id' from URL search params
 * @param relationships relationship array from modelDataAtom
 * @param existing any existing relationships for M-M relationship updates
 * @returns
 */
export const getRelationalParams = (
  originFrom: string | null,
  originId: string | null,
  relationships: any[],
  existing?: number[],
) => {
  const findRelation = relationships.find((r) => r.related_to === originFrom);
  if (originFrom === null || originId === null || !findRelation) return {};
  const relationId = parseInt(originId || "-1");
  const existingValues = existing || [];
  const relationshipValue =
    findRelation.type === "M-M" ? [...existingValues, relationId] : relationId;
  return {
    [`owner_${originFrom}_id`]: relationshipValue,
  };
};
